"use strict";

// ---------------------------------------------------------------
// Collection page
// ---------------------------------------------------------------




/*! Helper Functions -------------------------------------------------- */

// Saves a collection view preference to the cart attributes via a POST request
function saveCollectionview(attribute, value) {
	if (typeof routes === 'undefined' || !routes.cart_update_url) {
		console.warn('saveCollectionview skipped: routes.cart_update_url is not defined');
		return;
	}

	const config = {
		method: 'POST',
		body: JSON.stringify({
			attributes: {
				[attribute]: value
			}
		}),
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json',
			'Accept': 'application/javascript'
		}
	};
	fetch(routes.cart_update_url, config)
		.then(res => res.json())
		.then(res => {
			if (res.status) handleErrorMessage(res.description);
		})
		.catch(error => {
			console.warn('saveCollectionview error', error);
		});
}


// Inserts a new node immediately after a reference node in the DOM
function insertAfter(referenceNode, newNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}


// Keeps Product type options useful when only the first few values are visible.
function sortProductTypeFiltersByCount() {
	const lists = document.querySelectorAll('ul.check[data-filter-sort="count-desc"]');

	for (const list of lists) {
		const showMoreItem = list.querySelector(':scope > li.link-more');
		const options = Array.from(list.children).filter(item => !item.classList.contains('link-more'));

		options.sort((optionA, optionB) => {
			const optionASelected = optionA.querySelector('input:checked') ? 1 : 0;
			const optionBSelected = optionB.querySelector('input:checked') ? 1 : 0;

			if (optionASelected !== optionBSelected) return optionBSelected - optionASelected;

			const countDifference = Number(optionB.dataset.filterCount || 0) - Number(optionA.dataset.filterCount || 0);
			if (countDifference !== 0) return countDifference;

			return (optionA.dataset.filterLabel || '').localeCompare(
				optionB.dataset.filterLabel || '',
				'en',
				{ numeric: true, sensitivity: 'base' }
			);
		});

		for (const option of options) {
			list.insertBefore(option, showMoreItem);
		}

		const showMoreLink = showMoreItem ? showMoreItem.querySelector('a.link-more') : null;
		const visibleLimit = Number(showMoreLink ? showMoreLink.dataset.limit : 0) || 5;
		const isExpanded = list.classList.contains('link-more-clicked');

		options.forEach((option, index) => {
			option.classList.remove('hidden', 'was-hidden');
			if (!isExpanded && index >= visibleLimit) option.classList.add('hidden');
		});
	}
}

sortProductTypeFiltersByCount();


// Clears the min and max range filter inputs by removing their 'name' attributes to prevent them from submitting values
function clearRangeInputs() {
	const minInput = document.querySelector('#filter input#min');
	const maxInput = document.querySelector('#filter input#max');

	if (minInput) minInput.removeAttribute('name');
	if (maxInput) maxInput.removeAttribute('name');
};


// Clears all filter inputs: resets the range inputs and unchecks all selected checkboxes
function clearAllInputs() {
	clearRangeInputs();

	document.querySelectorAll('#filter input[type="checkbox"]:checked').forEach(el => el.checked = false);
};


// Attaches click listeners to collection product links to save the last clicked item URL in localStorage for "load more" functionality
function saveLoadMoreAnchor() {
	const anchors = document.querySelectorAll('#collection > li > figure > a, .m6cl .results > div a, .m6cl .results > .l4ne a');

	for (const el of anchors) {
		if (el.getAttribute('data-load-more-anchor-bound') === '1') continue;
		el.setAttribute('data-load-more-anchor-bound', '1');

		el.addEventListener('click', () => {
			localStorage.setItem('loadMoreItemClicked', el.getAttribute('href'));
		});
	}
};




/*! Custom Events -------------------------------------------------- */

// Attaches click handlers to aside navigation toggle links, calling toggle_dropdowns_simple() on their parent element.  
const navAsideEvt = new CustomEvent('navAside');
window.addEventListener('navAside', () => {
	const nav_aside = document.querySelectorAll('.n6as a.toggle:not(.n6as-initialized)');

	if (!nav_aside) return;

	for (const el of nav_aside) {
		el.classList.add('n6as-initialized');
		el.addEventListener('click', e => {
			e.preventDefault();
			toggle_dropdowns_simple(el.parentElement);
		});
	}
});
window.dispatchEvent(navAsideEvt);


// .f8fl - manages the filter panel: initializes filter toggles, handles open/close actions, and toggles filter subsections on click or key events.  
let forceFormFilterRender = false;
let filtersDocumentListenersBound = false;
let latestRenderFormFilter = function () {};
let latestHandleFilterSub = function () {};

function handleFilterDocumentClick(event) {
	latestRenderFormFilter();

	if (event.target.closest('a[aria-controls="filter"]')) {
		html_tag.classList.add('has-filters');

		html_tag.classList.toggle('f8fl-open');
		if (!html_tag.classList.contains('f8fl-open')) hidePanels();

		if (event.target.closest('.m6pn')) overlayClose();

		getStickyFooters();
		new_css('css-filters', css_filters);
		new_css('css-search', css_search);

		event.preventDefault();
	}
}

function handleFilterDocumentKeyup(event) {
	if (event.key === ' ') {
		handleFilterDocumentClick(event);
		latestHandleFilterSub(event);
	}
}

const filtersEvt = new CustomEvent('filters');
window.addEventListener('filters', function (evt) {
	const form_filter = document.getElementsByClassName('f8fl');
	
	if (form_filter.length) {
		html_tag.classList.add('t1cl');
		let formFilterRendered = false;

		function renderFormFilter() {
			if (formFilterRendered) return;

			for (const el of form_filter) {
				append_url(el, 'Close', 'f8fl-toggle');

				const elementId = el.id;
				if (elementId) {
					const links = document.querySelectorAll(`[href="#${elementId}"]`);
					for (const link of links) {
						link.classList.add('f8fl-toggle');
					}
				}

				const headers = el.querySelectorAll('h1, h2, h3, h4, h5, h6');
				for (const header of headers) {
					append_url(header, 'Close', 'header-toggle');
				}
			}

			const toggles = document.getElementsByClassName('f8fl-toggle');
			for (const el of toggles) {
				el.setAttribute('aria-controls', 'filter');
			}

			formFilterRendered = true;
		}

		function handleFilterSub(event) {
			const link = event.target.closest('.f8fl a.header-toggle');
			if (!link) return;

			const closestH = link.closest('h1, h2, h3, h4, h5, h6');
			toggle_dropdowns_simple(closestH);

			if (closestH.classList.contains('toggle') && typeof runPaddingsForInputs === 'function') {
				for (const el of nextUntil(closestH, 'h1, h2, h3, h4, h5, h6')) {
					for (const input of el.querySelectorAll('[class*="input-"][class*="fix"]')) {
						runPaddingsForInputs(input);
					}
				}
			}

			if (!closestH.id) event.preventDefault();
		}

		latestRenderFormFilter = renderFormFilter;
		latestHandleFilterSub = handleFilterSub;

		if (forceFormFilterRender) {
			renderFormFilter();
			forceFormFilterRender = false;
		}
		if (!filtersDocumentListenersBound) {
			document.addEventListener('click', handleFilterDocumentClick);
			document.addEventListener('click', function (event) {
				latestHandleFilterSub(event);
			});
			document.addEventListener('keyup', handleFilterDocumentKeyup);
			filtersDocumentListenersBound = true;
		}
	} else {
		latestRenderFormFilter = function () {};
		latestHandleFilterSub = function () {};
	}


	function clearSortForm() {
		for (const el of form_sort) {
			el.classList.remove('fixed');
		}
		html_tag.classList.remove('f8sr-fixed');
	}

	const form_sort = document.getElementsByClassName('f8sr');
	if (form_sort.length) {
		Array.from(form_sort).forEach(function (form_cont) {
			html_tag.classList.add('t1cl');
			if ((form_cont.classList.contains('mobile-sticky') || form_cont.classList.contains('sticky')) && form_cont.getAttribute('data-f8sr-sticky-bound') !== '1') {
				form_cont.setAttribute('data-f8sr-sticky-bound', '1');

				const trickDiv = createElementWithClass('div', 'offset-dist');
				const trickDist = createElementWithClass('div', 'inner-dist');

				function updateTrickDistHeight(div) {
					if (!div || div.hasHeight || !form_cont) return;

					requestAnimationFrame(() => {
						const h = form_cont.offsetHeight;
						div.style.height = `${h}px`;
						root_styles.style.setProperty('--f8sr_height', `${h}px`);
						div.hasHeight = true;
					});
				}

				//let updateSearchHeightExecuted = false;
				let updateSearchHeightRAF = 0;

				function applySearchHeight() {
					updateSearchHeightRAF = 0;
					if (!search_id) return;

					const h = search_id.clientHeight;
					if (h <= 0) return;

					root_styles.style.setProperty('--search_height', `${h}px`);
					//updateSearchHeightExecuted = true;
				}

				function updateSearchHeight() {
					if (!updateSearchHeightRAF) {
						updateSearchHeightRAF = requestAnimationFrame(applySearchHeight);
					}
				}

				function createEventListeners(element) {
					window.addEventListener('scroll', function () {
						updateTrickDistHeight(element);
						updateSearchHeight();
					});
				}

				const observer = new IntersectionObserver(
					([e]) => {
						const boundingRect = e.boundingClientRect;

						if (e.isIntersecting) {
							const el_mod = form_cont.classList.contains('sticky') ? e.target.nextElementSibling : form_cont;
							el_mod.classList.remove('fixed');
							html_tag.classList.remove('f8sr-fixed');
						} else {
							const el_mod = form_cont.classList.contains('sticky') ? e.target.nextElementSibling : form_cont;
							if (boundingRect.top < 0) {
								el_mod.classList.add('fixed');
								html_tag.classList.add('f8sr-fixed');
							}
							if (boundingRect.bottom >= window.innerHeight) {
								el_mod.classList.remove('fixed');
								html_tag.classList.remove('f8sr-fixed');
							}
						}
					}, {
						threshold: [0, 1],
						rootMargin: "0px 0px 0px 0px"
					}
				);

				if (form_cont.classList.contains('sticky')) {
					const trg = form_cont;

					trickDist.classList.add('before-f8sr');
					form_cont.after(trickDiv);
					form_cont.before(trickDist);

					createEventListeners(form_cont.nextElementSibling);

					observer.observe(form_cont.previousElementSibling);
				} else if (form_cont.classList.contains('mobile-sticky') && form_cont.classList.contains('mobile-compact')) {
					const trg = form_cont.querySelector('.link-btn');

					if (trg) {
						if (trg.classList.contains('mobile-hide')) {
							form_cont.classList.add('btn-mobile-hide');
						}
					}

					form_cont.prepend(trickDiv);
					form_cont.prepend(trickDist);

					createEventListeners(form_cont.querySelector('.inner-dist'));

					observer.observe(form_cont.querySelector('.offset-dist'));
					if (trg !== undefined && trg !== null) {
						const clone_me = trg.cloneNode(true);
						clone_me.classList.add('clone');
						insertAfter(trg, clone_me);
					}
				}
			}

			const form_sort_list_view = form_cont.getElementsByClassName('l4vw');
			const form_sort_list_inline = form_cont.getElementsByClassName('l4in');

			if (getHtmlTheme() === 'xclusive') {
				const form_view_inputs = [...form_sort_list_view, ...form_sort_list_inline];

				if (form_view_inputs.length) {
					for (const el of form_view_inputs) {
						const targetId = el.getAttribute('aria-controls');
						if (!targetId) continue;

						const viewList = document.getElementById(targetId);

						for (const input of el.querySelectorAll('input')) {
							const parent = input.parentElement;

							parent.addEventListener('click', () => {
								const width = input.getAttribute('data-width');
								const widthMobile = input.getAttribute('data-width-mobile');
								const collectionImgView = input.getAttribute('data-collection_img_view');

								if (width) {
									viewList.classList.remove('w100', 'w50', 'w33', 'w25', 'w20');
									saveCollectionview('collection_grid_view', width);
									viewList.classList.add(width);

								} else if (widthMobile) {
									viewList.classList.remove('w100-mobile', 'w50-mobile');
									saveCollectionview('collection_grid_view_mobile', widthMobile);
									viewList.classList.add(widthMobile);

								} else if (collectionImgView) {
									saveCollectionview('collection_img_view', collectionImgView);

									const sliderPictures = viewList.querySelectorAll('li picture.slider');
									if (sliderPictures.length) {
										for (const pic of sliderPictures) {
											const firstChild = pic.firstChild;
											if (firstChild && firstChild.nodeName.toLowerCase() === 'div') {
												const slideTo = (collectionImgView !== 'first') ? (pic.querySelectorAll('.second-first').length ? 0 : 1) : (pic.querySelectorAll('.second-first').length ? 1 : 0);
												firstChild.swiper.slideTo(slideTo, 0, false);
											} else {
												const imgIndex = collectionImgView !== 'first' ? 2 : 1;
												let img = pic.querySelector(`img[data-index="${imgIndex}"]`);
												const closestLink = img.closest('a');
												if (closestLink) img = closestLink;
												pic.prepend(img);
											}
										}
									} else {
										for (const pic of viewList.querySelectorAll('li picture + picture')) {
											const li = pic.closest('li');
											if (collectionImgView !== 'first') {
												li.classList.add('second-img-first');
											} else {
												li.classList.remove('second-img-first');
											}
										}
									}
								}
							});
						}
					}
				}
			}

			if (getHtmlTheme() === 'xtra') {
				if (form_sort_list_view.length) {
					html_tag.classList.add('t1cl');

					for (const el of form_sort_list_view) {
						const targetId = el.getAttribute('aria-controls');
						if (!targetId) continue;

						const viewList = document.getElementById(targetId);
						const viewItems = el.querySelectorAll('li');

						for (const icon of el.querySelectorAll('a > i[class*="icon-view-"]')) {
							icon.parentElement.addEventListener('click', (e) => {
								for (const item of viewItems) item.classList.remove('active');

								if (icon.classList.contains('icon-view-list')) {
									saveCollectionview('collection_view', 'list');
									viewList.classList.add('list');
									form_cont.classList.add('list');

									for (const listIcon of el.querySelectorAll('a > i.icon-view-list')) {
										listIcon.closest('li').classList.add('active');
									}

									for (const linkMore of viewList.querySelectorAll('a.link-more')) {
										handleInfoAndList(linkMore);
									}
								}

								if (icon.classList.contains('icon-view-grid')) {
									saveCollectionview('collection_view', 'grid');
									viewList.classList.remove('list');
									form_cont.classList.remove('list');

									for (const gridIcon of el.querySelectorAll('a > i.icon-view-grid')) {
										gridIcon.closest('li').classList.add('active');
									}
								}

								e.preventDefault();
							});
						}
					}
				}

				if (form_sort_list_inline.length) {
					for (const el of form_sort_list_inline) {
						const targetId = el.getAttribute('aria-controls');
						if (!targetId) continue;

						const viewList = document.getElementById(targetId);

						for (const input of el.querySelectorAll('input')) {
							const parent = input.parentElement;

							parent.addEventListener('click', () => {
								let className = '';

								const width = input.getAttribute('data-width');
								const widthMobile = input.getAttribute('data-width-mobile');

								if (width) {
									viewList.classList.remove('w100', 'w50', 'w33', 'w25', 'w20');
									saveCollectionview('collection_grid_view', width);
									className = width;
								} else if (widthMobile) {
									viewList.classList.remove('w100-mobile', 'w50-mobile');
									saveCollectionview('collection_grid_view_mobile', widthMobile);
									className = widthMobile;
								}

								if (className) viewList.classList.add(className);
							});
						}
					}
				}
			}
		});
	}
});
window.dispatchEvent(filtersEvt);


// #filter - initializes and handles collection filters by fetching filtered products, updating the UI, managing drawer/sidebar behavior, and dispatching related events
const initFiltersEvt = new CustomEvent('initFilters');
const filterClearButtonsBound = new WeakSet();
const filterInputsBound = new WeakSet();
let currentFilterAbortController = null;
let latestFilterRequestId = 0;
let filterDebounceTimer = null;
const combineSaveScrollStorageKey = 'tuk-combine-save-scroll-target';

function getCollectionResultsScrollTarget(collectionSection) {
	const combineSaveCategories = document.querySelector('[data-tuk-offers-categories][data-template-view="combine-save"]');
	if (combineSaveCategories) return combineSaveCategories;

	return collectionSection.querySelector('.f8sr') || collectionSection.querySelector('#collection');
}

function scrollToCollectionResults(collectionSection) {
	const resultsStart = getCollectionResultsScrollTarget(collectionSection);
	if (!resultsStart) return;

	const rootStyles = getComputedStyle(document.documentElement);
	const stickyOffset = parseFloat(rootStyles.getPropertyValue('--sticky_offset')) || 0;
	const spacing = parseFloat(rootStyles.getPropertyValue('--rpp')) || 16;
	const targetTop = window.scrollY + resultsStart.getBoundingClientRect().top - stickyOffset - spacing;

	window.scrollTo({
		top: Math.max(0, targetTop),
		behavior: 'auto'
	});
}

function rememberCombineSaveScrollTarget() {
	if (!document.querySelector('[data-tuk-offers-categories][data-template-view="combine-save"]')) return;

	try {
		sessionStorage.setItem(combineSaveScrollStorageKey, 'true');
	} catch (error) {
		// Navigation still works when session storage is unavailable.
	}
}

function restoreCombineSaveScrollTarget() {
	let shouldRestore = false;

	try {
		shouldRestore = sessionStorage.getItem(combineSaveScrollStorageKey) === 'true';
		if (shouldRestore) sessionStorage.removeItem(combineSaveScrollStorageKey);
	} catch (error) {
		return;
	}

	if (!shouldRestore) return;

	const collectionGrid = document.getElementById('collection');
	const collectionSection = collectionGrid && collectionGrid.closest('[id^="shopify-section-"]');
	if (!collectionSection) return;

	requestAnimationFrame(function () {
		scrollToCollectionResults(collectionSection);

		// The first jump activates the theme's sticky header. Recalculate after
		// its 0.4s transition so the category row is not hidden underneath it.
		setTimeout(function () {
			scrollToCollectionResults(collectionSection);
		}, 450);
	});
}

window.addEventListener('pageshow', restoreCombineSaveScrollTarget);

window.addEventListener('initFilters', function (evt) {
	const filter_form = document.getElementById('filter');

	if (!filter_form) return;

	new_css('form-validation-css', validation_css);

	// Core function: read filter form state, fetch updated collection HTML, replace markup and re-init JS modules
	const processFilters = function () {
		if (filterDebounceTimer) {
			clearTimeout(filterDebounceTimer);
			filterDebounceTimer = null;
		}

		const filterRequestId = ++latestFilterRequestId;
		let filterFetchOptions = {};
		let filterAbortController = null;

		if (currentFilterAbortController) {
			currentFilterAbortController.abort();
		}

		if ('AbortController' in window) {
			filterAbortController = new AbortController();
			currentFilterAbortController = filterAbortController;
			filterFetchOptions = {
				signal: filterAbortController.signal
			};
		}

		// Get section template ID and corresponding collection section
		const filter_form_template = filter_form.dataset.template;
		let collectionSection = document.getElementById('shopify-section-' + filter_form_template);

		// Drawer (aside) instance for filters, if it exists
		let sidebarGlobal = document.querySelector('.filters-aside-initialized');

		// Add "processing" state to form and, if present, to collection list container
		filter_form.classList.add('processing');
		if (collectionSection.querySelector('.l4cl:not(.bls)')) {
			collectionSection.querySelector('.l4cl:not(.bls)').classList.add('processing');
		}

		// Handle price range inputs: if at default min/max, clear them so they do not affect filters
		const minInput = document.querySelector('#filter input#min'),
			maxInput = document.querySelector('#filter input#max');
		if ((minInput && maxInput) && minInput.value == minInput.getAttribute('min') && maxInput.value == maxInput.getAttribute('max')) {
			clearRangeInputs();
		}

		// Serialize filter form to query string
		const filterFormData = new FormData(document.getElementById('filter'));
		const filterSearchParams = new URLSearchParams(filterFormData);
		const activeDiscountSort = new URL(window.location.href).searchParams.get('tuk_sort');
		if (activeDiscountSort) filterSearchParams.set('tuk_sort', activeDiscountSort);
		const filterParams = filterSearchParams.toString();

		// Build URL for section rendering endpoint with current filters applied
		const filterUrl = window.location.pathname + '?section_id=' + filter_form_template + '&' + filterParams;

		// Fetch updated collection section HTML
		fetch(filterUrl, filterFetchOptions)
			.then((response) => {
				if (filterRequestId !== latestFilterRequestId) return null;
				if (!response.ok) {
					const error = new Error(response.status);
					console.warn(error);
				}
				return response.text();
			})
			.then((text) => {
				// A stale response must not render over the latest selected filters.
				if (filterRequestId !== latestFilterRequestId || text === null) return;

				// Parse response and extract updated section markup
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('#shopify-section-' + filter_form_template);

				// Preserve toggle state on filter headings (open/closed)
				Array.from(filter_form.querySelectorAll('h4[data-filter-toggle].toggle')).forEach(function (el) {
					const matchingToggle = resultsMarkup
						.querySelector('h4[data-filter-toggle="' + el.dataset.filterToggle + '"]');

					if (matchingToggle) {
						matchingToggle.classList.add('toggle');
					}
				});

				// Preserve "show more" state on filter lists (which lists had 'link-more-clicked')
				const toggledLinkMore = filter_form.querySelectorAll('ul[data-filter-toggle].link-more-clicked');

				// Replace collection section content with freshly rendered HTML
				collectionSection.innerHTML = resultsMarkup.innerHTML;

				// If filters drawer (aside) is enabled, sync drawer markup with new content
				if (document.querySelector('.filters-aside-initialized')) {

					// Replace HTML inside the drawer with updated filters
					const drawerMarkup = resultsMarkup.querySelector('#filters-aside')
					sidebarGlobal.innerHTML = drawerMarkup.innerHTML;

					// Add close link/button inside drawer
					append_url(sidebarGlobal, 'Close', 'm6pn-close');

					// Special handling for "xclusive" theme – use drawer markup as main collection container
					if (getHtmlTheme() === 'xclusive') {
						append_url(sidebarGlobal, 'Close', 'm6pn-close');
						collectionSection = sidebarGlobal;
					}

					// Remove duplicated filters section (non-initialized instance)
					document.querySelector('#filters-aside:not(.filters-aside-initialized)').remove();
				}

				sortProductTypeFiltersByCount();

				// Re-bind "show more" behavior on updated filter lists
				window.dispatchEvent(linkMoreEvt);

				// Re-open filter lists that had been expanded before AJAX reload
				Array.from(toggledLinkMore).forEach(function (el) {
					const selector = 'ul[data-filter-toggle="' + el.dataset.filterToggle + '"] a.link-more';
					const linkMore = collectionSection.querySelector(selector);

					if (linkMore) {
						linkMore.click();
					}
				});

				// Update URL in browser history so filters are shareable / back-button friendly
				history.pushState(
					{ filterParams },
					'',
					`${window.location.pathname}${filterParams && '?'.concat(filterParams)}`
				);

				// Re-initialize all JS modules that depend on dynamically replaced content
				window.dispatchEvent(collectionSortEvt);
				window.dispatchEvent(rangeSliderEvt);
				forceFormFilterRender = true;
				window.dispatchEvent(initFiltersEvt);
				window.dispatchEvent(filtersEvt);
				window.dispatchEvent(modulePanelEvt);
				window.dispatchEvent(ratingsEvt);
				window.dispatchEvent(semanticInputEvt);
				window.dispatchEvent(semanticSelectEvt);
				window.dispatchEvent(schemeTooltipEvt);
				window.dispatchEvent(popupsEvt);
				window.dispatchEvent(collectionLoadMoreEvt);
				window.dispatchEvent(listScrollableEvt);
				window.dispatchEvent(modulePanelAnchorEvt);
				window.dispatchEvent(productcardVariantsEvt);
				window.dispatchEvent(listCollectionSliderEvt);
				window.dispatchEvent(check_limit_event);
				ajaxCart.init();
				quickShop.init();
				window.dispatchEvent(heightLimitEvt);

				// Wait for the replaced grid and sticky elements to finish recalculating.
				requestAnimationFrame(function () {
					requestAnimationFrame(function () {
						scrollToCollectionResults(collectionSection);
					});
				});

				if (currentFilterAbortController === filterAbortController) {
					currentFilterAbortController = null;
				}
			})
			.catch((error) => {
				if (error && error.name === 'AbortError') return;
				console.warn("processFilters error", error);
				filter_form.classList.remove('processing');

				const processingCollection = collectionSection &&
					collectionSection.querySelector('.l4cl:not(.bls).processing');

				if (processingCollection) {
					processingCollection.classList.remove('processing');
				}

				if (currentFilterAbortController === filterAbortController) {
					currentFilterAbortController = null;
				}
			});
	};

	const scheduleProcessFilters = function () {
		// Invalidate pending filter renders during the debounce window.
		latestFilterRequestId++;
		if (currentFilterAbortController) {
			currentFilterAbortController.abort();
			currentFilterAbortController = null;
		}

		if (filterDebounceTimer) clearTimeout(filterDebounceTimer);
		filterDebounceTimer = setTimeout(function () {
			filterDebounceTimer = null;
			processFilters();
		}, 125);
	};

	// Disable clicks on anchors inside filter labels – they should not navigate, only toggle inputs
	const formFilterInputAnchors = filter_form.querySelectorAll('li label a');
	formFilterInputAnchors.forEach(el => el.classList.add('no-click'));

	// Handle "Clear all" and "Clear range" actions in filter UI
	const formFilterClear = filter_form.querySelectorAll('a.remove-all, a.clear-range');
	formFilterClear.forEach(el => {
		if (filterClearButtonsBound.has(el)) return;
		filterClearButtonsBound.add(el);

		el.addEventListener('click', e => {
			e.preventDefault();
			el.classList.contains('remove-all') ? clearAllInputs() : clearRangeInputs();
			processFilters();
		});
	});

	// Trigger filtering whenever any filter input changes
	const formFilterInputs = document.querySelectorAll('#filter input');
	formFilterInputs.forEach(el => {
		if (filterInputsBound.has(el)) return;
		filterInputsBound.add(el);

		el.addEventListener('change', scheduleProcessFilters);
	});

	// Determine filter layout (drawer vs static) and current collection wrapper / config
	const filterRoot = document.getElementById('filter');
	const layout = filterRoot.dataset.drawer;
	const collectionWrapper = document.querySelector('.collection-wrapper');
	const filters = collectionWrapper && collectionWrapper.dataset ? collectionWrapper.dataset.filters : undefined;
	const filtersDrawerContent = document.querySelector('#filters-aside');

	// If configuration is inconsistent (drawer markup with static layout or vice versa), clean up and exit
	if ((filtersDrawerContent && layout === 'static') || (!filters && layout === 'drawer')) {
		const initialized = document.querySelector('#root .filters-aside-initialized');
		if (initialized) {
			initialized.remove();
		}
		hidePanels();
		return;
	}

	// Initialize or update drawer layout for filters when layout === 'drawer'
	if (layout === 'drawer' && filtersDrawerContent) {
		const editor = filtersDrawerContent.dataset.editor;
		let initialized = document.querySelector('#root .filters-aside-initialized');

		// First-time initialization: move filters aside markup into root and mark it as initialized
		if (!initialized) {
			document.querySelector('#root').appendChild(filtersDrawerContent);
			filtersDrawerContent.classList.add('filters-aside-initialized');
		}
		// Theme editor handling: sync visibility and reset processed state
		else if (editor) {
			if (filtersDrawerContent.classList.contains('inv')) {
				initialized.classList.add('inv');
			} else {
				initialized.classList.remove('inv');
			}
			initialized.classList.remove('processed-filter');
		}

		// Re-init navigation / aside panel logic for the drawer
		window.dispatchEvent(navAsideEvt);
	}
});
window.dispatchEvent(initFiltersEvt);


// #load-more-button - handles "Load More" buttons on collection pages by fetching and appending or prepending products, updating pagination, URL, and related UI components
const collectionLoadMoreEvt = new CustomEvent('collectionLoadMore');
let collectionInfiniteScrollObserver;

function preserveCollectionTemplateView(button) {
	const templateSection = document.querySelector('[data-tuk-offers-categories][data-template-view]');
	const templateView = templateSection && templateSection.dataset.templateView;
	if (!button || !templateView || !button.getAttribute('href') || button.getAttribute('href').charAt(0) === '#') return;

	const currentView = new URL(window.location.href).searchParams.get('view');
	const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
	if (currentView !== templateView && !isThemeEditor) return;

	const url = new URL(button.getAttribute('href'), window.location.origin);
	url.searchParams.set('view', templateView);
	button.setAttribute('href', url.toString());
}

// Load adjacent collection pages before the visitor reaches either pagination control.
function initCollectionInfiniteScroll() {
	if (!('IntersectionObserver' in window)) return;

	if (collectionInfiniteScrollObserver) {
		collectionInfiniteScrollObserver.disconnect();
	}

	const buttons = document.querySelectorAll('#load-more-button[data-next]:not(.loading), #load-more-button[data-prev]:not(.loading)');
	if (!buttons.length) return;

	collectionInfiniteScrollObserver = new IntersectionObserver(function (entries) {
		for (const entry of entries) {
			const button = entry.target;
			if (!entry.isIntersecting || button.classList.contains('loading')) continue;

			collectionInfiniteScrollObserver.unobserve(button);
			button.click();
		}
	}, {
		rootMargin: '800px 0px',
		threshold: 0
	});

	Array.from(buttons).forEach(function (button) {
		preserveCollectionTemplateView(button);
		collectionInfiniteScrollObserver.observe(button);
	});
}

function deferLoadMoreEnhancements(callback) {
	if (typeof runWhenIdle === 'function') {
		runWhenIdle(callback);
		return;
	}

	requestAnimationFrame(function () {
		setTimeout(callback, 0);
	});
}

window.addEventListener('collectionLoadMore', function (evt) {
	const collection_load_more = document.querySelectorAll('#load-more-button[data-next], #load-more-button[data-prev]');

	if (!collection_load_more) return;

	Array.from(collection_load_more).forEach(function (button) {
		if (button.getAttribute('data-collection-load-more-bound') === '1') return;
		button.setAttribute('data-collection-load-more-bound', '1');

			button.addEventListener('click', function (e) {
				e.preventDefault();
				preserveCollectionTemplateView(button);
				var template = button.getAttribute('data-section'),
				collectionSection = document.getElementById('shopify-section-' + template),
				curr_products = collectionSection.querySelector('.results, .l4cl:not(.bls, .category)'),
				pagination_info = document.getElementById('load-more-info');
			if (button.getAttribute('data-next') != null) {
				var direction = 'next'
			} else {
				var direction = 'prev';
			}
			button.classList.add('loading');
			fetch(button.getAttribute('href'))
				.then((response) => {
					if (!response.ok) throw new Error('Unable to load collection page: ' + response.status);
					return response.text();
				})
				.then((text) => {
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + template);
					if (!resultsMarkup) throw new Error('The requested collection template was not returned');
					var new_products = resultsMarkup.querySelector('.results, .l4cl:not(.bls, .category)'),
						new_button = resultsMarkup.querySelector('#load-more-button[data-' + direction + '], #load-more-button[data-top]'),
						new_pagination_info = resultsMarkup.querySelector('#load-more-info');
					preserveCollectionTemplateView(new_button);

					if (direction == 'prev') {
						var lastGridHeight = curr_products.getBoundingClientRect().height,
							lastWindowScroll = window.scrollY;
					}
					if (curr_products && new_products) {
						const productsFragment = document.createDocumentFragment();

						if (direction == 'next') {
							while (new_products.firstElementChild) {
								productsFragment.appendChild(new_products.firstElementChild);
							}
							curr_products.appendChild(productsFragment);
						} else {
							while (new_products.firstElementChild) {
								productsFragment.appendChild(new_products.firstElementChild);
							}
							curr_products.insertBefore(productsFragment, curr_products.firstChild);
						}
					}
					if (direction == 'next' && pagination_info && pagination_info.parentNode && new_pagination_info) {
						pagination_info.parentNode.replaceChild(new_pagination_info, pagination_info);
					}
					if (button && button.parentNode && new_button) {
						button.parentNode.replaceChild(new_button, button);
					} else if (button && direction == 'prev') {
						button.parentNode.remove();
					}
					if (direction == 'prev') {
						var scrollDiff = curr_products.getBoundingClientRect().height - lastGridHeight;
						window.scrollTo({
							top: lastWindowScroll + scrollDiff,
							behavior: 'instant',
						});
					}
					window.history.replaceState({}, '', button.getAttribute('href'));
					saveLoadMoreAnchor();

					window.dispatchEvent(semanticInputEvt);
					window.dispatchEvent(collectionLoadMoreEvt);
					window.dispatchEvent(listScrollableEvt);
					window.dispatchEvent(productVariantsEvt);
					window.dispatchEvent(semanticSelectEvt);
					window.dispatchEvent(check_limit_event);
					ajaxCart.init();
					quickShop.init();

					deferLoadMoreEnhancements(function () {
						window.dispatchEvent(ratingsEvt);
						window.dispatchEvent(schemeTooltipEvt);
						window.dispatchEvent(popupsEvt);
						window.dispatchEvent(formZindexEvt);
					});
				})
				.catch((error) => {
					console.warn("collectionLoadMore error", error);
					button.classList.remove('loading');
				});
		});
	});

	initCollectionInfiniteScroll();
});
window.dispatchEvent(collectionLoadMoreEvt);


// #sort_by - handles native Shopify sorting and collection-wide discount percentage sorting.
const collectionSortEvt = new CustomEvent('collectionSort');
const tukDiscountSortParam = 'tuk_sort';
const tukDiscountSortValues = ['discount-descending', 'discount-ascending'];
const tukDiscountSortSectionId = 'tuk-discount-sort-products';
const tukDiscountSortCachePrefix = 'tuk-discount-sort-v1:';
const tukDiscountSortCacheTtl = 5 * 60 * 1000;
let tukDiscountSortAbortController = null;
let tukDiscountSortRequestId = 0;
let tukDiscountSortAppliedSignature = '';

function getTukDiscountSortValue() {
	const value = new URL(window.location.href).searchParams.get(tukDiscountSortParam);
	return tukDiscountSortValues.includes(value) ? value : '';
}

function getTukDiscountSortSignature() {
	const url = new URL(window.location.href);
	url.searchParams.delete('page');
	url.searchParams.delete('section_id');
	url.hash = '';
	return url.pathname + '?' + url.searchParams.toString();
}

function navigateToCollectionSort(value) {
	const url = new URL(window.location.href);
	url.searchParams.delete('page');

	if (value.indexOf('tuk-') === 0) {
		url.searchParams.set(tukDiscountSortParam, value.replace('tuk-', ''));
	} else {
		url.searchParams.delete(tukDiscountSortParam);
		url.searchParams.set('sort_by', value);
	}

	rememberCombineSaveScrollTarget();
	window.location.search = url.searchParams.toString();
}

function syncTukDiscountSortControls() {
	const value = getTukDiscountSortValue();
	const select = document.getElementById('sort_by');

	if (select && value && select.querySelector('option[value="tuk-' + value + '"]')) {
		const optionValue = 'tuk-' + value;
		select.value = optionValue;
		Array.from(select.options).forEach(function (option) {
			option.toggleAttribute('selected', option.value === optionValue);
		});

		const customSelect = select.nextElementSibling;
		if (customSelect && customSelect.classList.contains('bv_mainselect')) {
			const selectedOption = select.options[select.selectedIndex];
			const currentLabel = customSelect.querySelector('.bv_atual .sl_inner');
			const customOptions = customSelect.querySelectorAll('.bv_ul_inner .li:not(.nofocus)');

			if (currentLabel && selectedOption) currentLabel.textContent = selectedOption.text.trim();
			customOptions.forEach(function (option, index) {
				option.classList.toggle('bv_selected', index === select.selectedIndex);
			});
		}
	}

	if (value) {
		document.querySelectorAll('.tuk-filter-sort button').forEach(function (button) {
			button.classList.toggle('active', button.dataset.tukDiscountSort === value);
		});
	}
}

function bindTukCollectionSortControls() {
	const sortSelect = document.getElementById('sort_by');
	if (sortSelect && sortSelect.getAttribute('data-collection-sort-bound') !== '1') {
		sortSelect.setAttribute('data-collection-sort-bound', '1');
		sortSelect.addEventListener('change', function () {
			const sortByClone = document.querySelector('.sort_by_clone');
			if (sortByClone && this.value.indexOf('tuk-') !== 0) sortByClone.value = this.value;
			navigateToCollectionSort(this.value);
		});
	}

	document.querySelectorAll('[data-tuk-native-sort]').forEach(function (button) {
		if (button.getAttribute('data-tuk-sort-bound') === '1') return;
		button.setAttribute('data-tuk-sort-bound', '1');
		button.addEventListener('click', function () {
			const select = document.getElementById('sort_by');
			if (!select) return;
			select.value = this.value;
			select.dispatchEvent(new Event('change', { bubbles: true }));
		});
	});

	document.querySelectorAll('[data-tuk-discount-sort]').forEach(function (button) {
		if (button.getAttribute('data-tuk-sort-bound') === '1') return;
		button.setAttribute('data-tuk-sort-bound', '1');
		button.addEventListener('click', function () {
			navigateToCollectionSort('tuk-' + this.value);
		});
	});

	syncTukDiscountSortControls();
}

function buildTukDiscountDataUrl(page) {
	const url = new URL(window.location.href);
	url.searchParams.delete(tukDiscountSortParam);
	url.searchParams.delete('tuk_offer_category');
	url.searchParams.delete('page');
	url.searchParams.set('section_id', tukDiscountSortSectionId);
	if (page > 1) url.searchParams.set('page', page);
	return url.toString();
}

function readTukDiscountDataCache(url) {
	try {
		const cached = JSON.parse(sessionStorage.getItem(tukDiscountSortCachePrefix + url));
		if (!cached || !cached.markup || Date.now() - cached.storedAt > tukDiscountSortCacheTtl) return '';
		return cached.markup;
	} catch (error) {
		return '';
	}
}

function writeTukDiscountDataCache(url, markup) {
	try {
		sessionStorage.setItem(tukDiscountSortCachePrefix + url, JSON.stringify({
			storedAt: Date.now(),
			markup: markup
		}));
	} catch (error) {
		// Sorting remains available when browser storage is disabled or full.
	}
}

async function fetchTukDiscountDataPage(page, signal) {
	const url = buildTukDiscountDataUrl(page);
	let markupText = readTukDiscountDataCache(url);

	if (!markupText) {
		const response = await fetch(url, { signal: signal });
		if (!response.ok) throw new Error('Unable to load discount sort data page ' + page + ': ' + response.status);
		markupText = await response.text();
		writeTukDiscountDataCache(url, markupText);
	}

	const markup = new DOMParser().parseFromString(markupText, 'text/html');
	const productList = markup.querySelector('#tuk-discount-products');
	if (!productList) {
		throw new Error('Discount sort data page ' + page + ' did not return the product list');
	}
	return productList;
}

async function fetchTukDiscountCards(signal) {
	const firstPage = await fetchTukDiscountDataPage(1, signal);
	const pageCount = Math.max(1, Number(firstPage.dataset.tukPaginationPages || 1));
	const expectedResultCount = Math.max(0, Number(firstPage.dataset.tukResultCount || 0));
	const pages = new Array(pageCount);
	pages[0] = firstPage;

	let nextPage = 2;
	const workerCount = Math.min(4, Math.max(0, pageCount - 1));
	const workers = Array.from({ length: workerCount }, async function () {
		while (nextPage <= pageCount) {
			const page = nextPage++;
			pages[page - 1] = await fetchTukDiscountDataPage(page, signal);
		}
	});

	await Promise.all(workers);
	const cards = [];
	const seenProducts = new Set();

	pages.forEach(function (productList) {
		productList.querySelectorAll(':scope > [data-tuk-product-id]').forEach(function (card) {
			const productId = card.dataset.tukProductId;
			if (!productId || seenProducts.has(productId)) return;
			seenProducts.add(productId);
			cards.push(card);
		});
	});

	if (expectedResultCount && cards.length !== expectedResultCount) {
		throw new Error('Discount sort returned ' + cards.length + ' of ' + expectedResultCount + ' products');
	}
	return cards;
}

function sortTukDiscountCards(cards, direction) {
	return cards
		.map(function (card, index) {
			return {
				card: card,
				discount: Math.max(0, Number(card.dataset.tukDiscount || 0)),
				originalIndex: index
			};
		})
		.sort(function (itemA, itemB) {
			const itemAHasDiscount = itemA.discount > 0;
			const itemBHasDiscount = itemB.discount > 0;

			if (itemAHasDiscount !== itemBHasDiscount) return itemAHasDiscount ? -1 : 1;
			if (itemAHasDiscount && itemA.discount !== itemB.discount) {
				return direction === 'discount-ascending'
					? itemA.discount - itemB.discount
					: itemB.discount - itemA.discount;
			}
			return itemA.originalIndex - itemB.originalIndex;
		})
		.map(function (item) { return item.card; });
}

function updateTukDiscountProgress(section, seen, total) {
	const info = section.querySelector('#load-more-info');
	if (!info) return;

	const label = info.querySelector(':scope > p');
	const labelTemplate = info.dataset.tukLabelTemplate;
	if (label && labelTemplate) {
		label.innerHTML = labelTemplate
			.replace('__TUK_SEEN__', String(seen))
			.replace('__TUK_TOTAL__', String(total));
	}

	info.dataset.tukSeen = String(seen);
	info.dataset.tukTotal = String(total);
	const bar = info.querySelector('.bar');
	if (bar) bar.style.width = (total ? (seen / total) * 100 : 100) + '%';
}

function removeTukDiscountLoadMore(button) {
	const container = button && button.closest('p');
	if (!container) return;
	const divider = container.previousElementSibling;
	if (divider && divider.tagName === 'HR') divider.remove();
	container.remove();
}

function setupTukDiscountProgressiveDisplay(section, cards, pageSize) {
	cards.forEach(function (card, index) {
		card.dataset.tukDiscountIndex = String(index);
		card.classList.toggle('hidden', index >= pageSize);
	});

	let button = section.querySelector('#load-more-button[data-next]');
	const initialSeen = Math.min(pageSize, cards.length);
	updateTukDiscountProgress(section, initialSeen, cards.length);

	if (!button || cards.length <= pageSize) {
		if (button) removeTukDiscountLoadMore(button);
		return;
	}

	const cleanButton = button.cloneNode(true);
	button.replaceWith(cleanButton);
	button = cleanButton;
	button.removeAttribute('data-next');
	button.removeAttribute('data-prev');
	button.removeAttribute('data-collection-load-more-bound');
	button.href = '#collection';
	button.setAttribute('data-tuk-discount-load-more', '');
	button.addEventListener('click', function (event) {
		event.preventDefault();
		const hiddenCards = cards.filter(function (card) { return card.classList.contains('hidden'); });
		hiddenCards.slice(0, pageSize).forEach(function (card) { card.classList.remove('hidden'); });

		const seen = cards.length - cards.filter(function (card) { return card.classList.contains('hidden'); }).length;
		updateTukDiscountProgress(section, seen, cards.length);
		if (seen >= cards.length) removeTukDiscountLoadMore(button);
	});
}

function reinitializeTukDiscountCollection() {
	[
		'ratings',
		'semanticInput',
		'schemeTooltip',
		'popups',
		'listScrollable',
		'productcardVariants',
		'listCollectionSlider',
		'check-limit-event',
		'heightLimit'
	].forEach(function (eventName) {
		window.dispatchEvent(new CustomEvent(eventName));
	});
	if (window.ajaxCart && typeof window.ajaxCart.init === 'function') window.ajaxCart.init();
	if (window.quickShop && typeof window.quickShop.init === 'function') window.quickShop.init();
	bindTukCollectionSortControls();
}

async function applyTukDiscountSort() {
	const value = getTukDiscountSortValue();
	const filterForm = document.querySelector('#filter[data-tuk-discount-sorting]');
	if (!value || !filterForm) return;

	const signature = getTukDiscountSortSignature();
	if (signature === tukDiscountSortAppliedSignature) return;

	if (tukDiscountSortAbortController) tukDiscountSortAbortController.abort();
	tukDiscountSortAbortController = 'AbortController' in window ? new AbortController() : null;
	const signal = tukDiscountSortAbortController ? tukDiscountSortAbortController.signal : undefined;
	const requestId = ++tukDiscountSortRequestId;
	const liveSection = document.getElementById('shopify-section-' + filterForm.dataset.template);
	const liveGrid = liveSection && liveSection.querySelector('#collection');

	if (!liveSection || !liveGrid) return;
	liveGrid.classList.add('processing');
	liveGrid.setAttribute('aria-busy', 'true');

	try {
		const pageSize = Math.max(1, Number(liveGrid.dataset.tukPageSize || 12));
		const cards = sortTukDiscountCards(await fetchTukDiscountCards(signal), value);

		if (requestId !== tukDiscountSortRequestId) return;

		const sortedGrid = liveGrid;
		sortedGrid.replaceChildren();
		cards.forEach(function (card) { sortedGrid.appendChild(card); });
		sortedGrid.dataset.tukDiscountComplete = 'true';
		sortedGrid.dataset.tukDiscountResultCount = String(cards.length);
		sortedGrid.classList.remove('processing');
		sortedGrid.removeAttribute('aria-busy');

		setupTukDiscountProgressiveDisplay(liveSection, cards, pageSize);
		tukDiscountSortAppliedSignature = signature;
		reinitializeTukDiscountCollection();
		syncTukDiscountSortControls();
		window.dispatchEvent(new CustomEvent('tukDiscountSortComplete', { detail: { success: true } }));
	} catch (error) {
		if (error && error.name === 'AbortError') return;
		console.warn('Discount percentage sorting could not be applied', error);
		liveGrid.classList.remove('processing');
		liveGrid.removeAttribute('aria-busy');
		window.dispatchEvent(new CustomEvent('tukDiscountSortComplete', { detail: { success: false } }));
	} finally {
		if (requestId === tukDiscountSortRequestId) tukDiscountSortAbortController = null;
	}
}

window.addEventListener('collectionSort', function () {
	bindTukCollectionSortControls();
	applyTukDiscountSort();
});
function scheduleTukDiscountSortControlSync() {
	requestAnimationFrame(function () {
		requestAnimationFrame(syncTukDiscountSortControls);
	});
	setTimeout(syncTukDiscountSortControls, 100);
}
window.addEventListener('popstate', function () {
	tukDiscountSortAppliedSignature = '';
	bindTukCollectionSortControls();
	syncTukDiscountSortControls();
	scheduleTukDiscountSortControlSync();
	applyTukDiscountSort();
});
window.addEventListener('pageshow', function () {
	bindTukCollectionSortControls();
	syncTukDiscountSortControls();
	scheduleTukDiscountSortControlSync();
});
window.dispatchEvent(collectionSortEvt);
